import moment from "moment";
import PatientTypeTag from "components/Dashboard/DoctorDashboard/patient-charts/components/patient-type-tag/PatientTypeTag";
import { useUser } from "contexts/UserContext";
import { convertSecToMin } from "../../utils/convertSecToMin";
import { DOB_FORMAT } from "components/patient-editor/constants/dobFormat";
import styles from "./AssessmentSideInfo.module.scss";

const AssessmentSideInfo = ({
  metaData,
  isUserPro,
  isAssessmentTemplate,
  isAssessment,
}) => {
  const { defaultUserTimezone } = useUser();
  /* assessment is only for adult right now  */
  return isAssessmentTemplate ? (
    <div className={styles["side-info-patient"]}>
      <div className={styles["side-info__title"]}>Patient preferred name</div>
      <div className={styles["side-info__content"]}>-</div>

      <div className={styles["side-info__title"]}>DOB</div>
      <div className={styles["side-info__content"]}>-</div>

      <div className={styles["side-info__title"]}>Assessment status</div>
      <div className={styles["side-info__content"]}>-</div>

      <div className={styles["side-info__title"]}>Time to complete</div>
      <div className={styles["side-info__content"]}>-</div>
    </div>
  ) : isUserPro ? (
    <div>
      <div className={styles["side-info__patient-type-tag"]}>
        <PatientTypeTag type={"adult"} />
      </div>
      {metaData?.patient && (
        <>
          <div className={styles["side-info__title"]}>
            Patient preferred name
          </div>
          <div className={styles["side-info__content"]}>{`${
            metaData.patient.first_name || ""
          } ${metaData.patient.last_name || ""}`}</div>
        </>
      )}

      {metaData?.patient?.dob && (
        <>
          <div className={styles["side-info__title"]}>DOB</div>
          <div className={styles["side-info__content"]}>
            {moment
              .tz(metaData.patient.dob, defaultUserTimezone)
              .format(DOB_FORMAT)}
          </div>
        </>
      )}

      <div className={styles["side-info__title"]}>Assessment status</div>
      <div className={styles["side-info__content"]}>
        {!metaData?.completed_timestamp ? (
          "Pending"
        ) : (
          <div>
            Signed & submitted <br />
            {`${new Date(metaData?.completed_timestamp).toLocaleDateString(
              "en-US",
              {
                hour: "2-digit",
                minute: "2-digit",
              },
            )}`}
          </div>
        )}
      </div>
      {isAssessment && (
        <>
          <div className={styles["side-info__title"]}>Time to complete</div>
          <div className={styles["side-info__content"]}>
            {!metaData?.time_to_complete_seconds
              ? "-"
              : convertSecToMin(metaData?.time_to_complete_seconds)}
          </div>
        </>
      )}
    </div>
  ) : (
    <div className={styles["side-info-patient"]}>
      {metaData?.orchid_pro && (
        <>
          <div className={styles["side-info__title"]}>Primary Clinician</div>
          <div className={styles["side-info__content"]}>{`${
            metaData.orchid_pro.first_name || ""
          } ${metaData.orchid_pro.last_name || ""}`}</div>
        </>
      )}

      <div className={styles["side-info__title"]}>Assessment status</div>
      <div className={styles["side-info__content"]}>
        {!metaData?.completed_timestamp ? (
          "Pending"
        ) : (
          <div>
            Signed & submitted <br />
            {`${new Date(metaData?.completed_timestamp).toLocaleDateString(
              "en-US",
              {
                hour: "2-digit",
                minute: "2-digit",
              },
            )}`}
          </div>
        )}
      </div>

      {isAssessment && (
        <>
          <div className={styles["side-info__title"]}>Time to complete</div>
          <div className={styles["side-info__content"]}>
            {!metaData?.time_to_complete_seconds
              ? "-"
              : convertSecToMin(metaData?.time_to_complete_seconds)}
          </div>
        </>
      )}
    </div>
  );
};

export default AssessmentSideInfo;
